<template>
  <div
    class="container-fluid"
    style="
      position: absolute;
      min-width: 100%;
      min-height: 100%;
      max-width: 100%;
      display: flex;
      align-items: center;
    "
  >
    <!--bg-maintenance-image-->

    <QrCode ref="QrCode" :name="'QrCode'" :serialME="true" @onQr="getQr" />

    <div class="col-md-6 offset-md-3 col-xs-12 pt-1">
      <div class="card border-grey border-lighten-3 px-1 py-1 box-shadow-3">
        <div class="card-block text-xs-center">
          <ul class="nav navbar-nav float-xs-right">
            <li class="dropdown dropdown-language nav-item">
              <a
                id="dropdown-flag"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                class="btn dropdown-toggle nav-link"
              >
                <i
                  ref="lang_btn"
                  class="flag-icon"
                  :class="$i18n.tc('lang.logo', $i18n.locale)"
                ></i>
                <span class="selected-language">
                  {{ $i18n.tc("lang.title", $i18n.locale) }}</span
                >
              </a>

              <div aria-labelledby="dropdown-flag" class="dropdown-menu">
                <a
                  class="dropdown-item"
                  :id="lang"
                  v-for="(lang, index) in listLanguages"
                  :key="index"
                  @click="changeLanguage(lang)"
                >
                  <i
                    class="flag-icon"
                    :class="$i18n.getLocaleMessage(lang).lang.logo"
                  ></i>
                  {{ $i18n.getLocaleMessage(lang).lang.title }}
                </a>
              </div>
            </li>
          </ul>

          <span class="card-title text-xs-center">
            <a @click="openURL('https://modern-expo.eu')">
              <!-- <img src="../assets/pictures/me_logo.png" class="img-fluid mx-auto d-block pt-2" width="250" alt="logo"> -->
              <svg class="d-flex me_logo w-100 d-block" />
            </a>
          </span>
        </div>
        <div class="card-block">
          <form class="form">
            <div class="card-text">
              <p>
                {{ $t("registr.lbl.enter") }}
                <code>{{ $t("equipm.table.serNumber") }}</code>
                {{ $t("registr.lbl.or") }}
                <code>{{ $t("equipm.table.codeModel") }}</code>
                {{ $t("registr.lbl.ofrefr") }}
              </p>
            </div>

            <div class="form-group">
              <label for="serial">{{ $t("equipm.table.serNumber") }}</label>
              <div class="row center">
                <div class="col-md-6">
                  <div class="position-relative has-icon-left">
                    <input
                      class="form-control border-primary"
                      type="text"
                      id="serial"
                      v-model="dataEquipment.serial"
                      @keyup.enter="
                        find.bySer = true;
                        find.byModel = false;
                        getEqInfo(dataEquipment.serial);
                      "
                    />
                    <div class="form-control-position">
                      <i class="icon-qrcode"></i>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="
                      find.bySer = true;
                      find.byModel = false;
                      getEqInfo(dataEquipment.serial);
                    "
                  >
                    <i class="icon-search4"></i> {{ $t("users.hint.find") }}
                  </button>
                  <button
                    type="button"
                    class="btn btn-warning"
                    @click="
                      find.byModel = false;
                      find.bySer = true;
                      showModalQR();
                    "
                    data-html="true"
                    :title="$t('equipm.hint.scanQr')"
                  >
                    <i style="color: #ffffff" class="icon-qrcode"></i>
                    {{ $t("equipm.hint.scanQr") }}
                  </button>
                </div>
              </div>
            </div>

            <div class="row" v-if="showinfo">
              <div class="col-md-12 d-flex" style="justify-content: flex-end">
                <button
                  type="button"
                  class="btn btn-black"
                  @click="createAppeal()"
                >
                  <i class="icon-plus"></i> {{ $t("problem.titles.add") }}
                </button>
              </div>
            </div>

            <div class="form-group">
              <label for="model">{{ $t("equipm.table.codeModel") }}</label>
              <div class="row center">
                <div class="col-md-6">
                  <div class="position-relative has-icon-left">
                    <input
                      class="form-control border-primary"
                      type="text"
                      id="model"
                      v-model="dataEquipment.model"
                      @keyup.enter="
                        find.bySer = false;
                        find.byModel = true;
                        getEqInfo('');
                      "
                    />
                    <div class="form-control-position">
                      <i class="icon-price-tag"></i>
                    </div>
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="
                      find.bySer = false;
                      find.byModel = true;
                      getEqInfo('');
                    "
                  >
                    <i class="icon-search4"></i> {{ $t("users.hint.find") }}
                  </button>
                </div>
              </div>
            </div>

            <!-- <div class="card-block text-xs-center" v-show="$store.state.isLoading">
              <div class="mt-2"><i class="icon-gear-a spinner font-large-2"></i></div>
            </div> -->

            <div class="form-body" v-if="showInstr">
              <h4 class="form-section">
                <i class="icon-file-text2"></i
                >{{ $t("equipm.table.instructions") }}:
                {{ dataEquipment.model }}
              </h4>
              <div
                class="form-group"
                v-if="dataEquipment.instructions.length > 0"
              >
                <div
                  class="col-md-12"
                  v-for="(file, index) in dataEquipment.instructions"
                  :key="index"
                >
                  <a>
                    <h4 @click="bringfile(file.name)">
                      <img
                        :src="getIcon(file.name)"
                        style="max-height: 2rem; min-height: 1rem"
                      />
                      <span style="text-decoration: underline">{{
                        file.name
                      }}</span>
                    </h4>
                  </a>
                </div>
              </div>
            </div>

            <div class="form-body" v-if="showinfo">
              <h4 class="form-section">
                <i class="icon-eye6"></i> {{ $t("equipm.titles.about") }}
              </h4>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="userinput3">{{
                      $t("equipm.table.codeModel")
                    }}</label>
                    <div class="position-relative has-icon-left">
                      <input
                        class="form-control border-primary"
                        type="text"
                        id="model"
                        v-model="dataEquipment.model"
                        disabled
                      />
                      <div class="form-control-position">
                        <i class="icon-price-tag"></i>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="userinput3">{{
                      $t("equipm.table.articule")
                    }}</label>
                    <div class="position-relative has-icon-left">
                      <input
                        type="text"
                        id="userinput3"
                        class="form-control border-primary"
                        name="type"
                        v-model="dataEquipment.article"
                        disabled
                      />
                      <div class="form-control-position">
                        <i class="icon-price-tags"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label for="userinput2">{{ $t("equipm.table.nameEq") }}</label>
                <!--<input type="text" id="userinput2" class="form-control border-primary" name="name" v-model="dataEquipment.name" disabled>-->
                <textarea
                  id="userinput2"
                  rows="5"
                  class="form-control border-primary"
                  v-model="dataEquipment.name"
                  disabled
                ></textarea>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="dtinput1">{{
                      $t("equipm.table.shipmDate")
                    }}</label>
                    <div class="position-relative has-icon-left">
                      <!--<input type="date" id="dtinput1" class="form-control" name="dtShipment" v-model="dataEquipment.dates.shipment" disabled>-->
                      <input
                        type="text"
                        id="dtinput1"
                        class="form-control"
                        name="dtShipment"
                        v-model="dataEquipment.dates.shipment"
                        disabled
                      />
                      <div class="form-control-position">
                        <i class="icon-calendar3"></i>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="dtinput2">{{
                      $t("equipm.table.manufDate")
                    }}</label>
                    <div class="position-relative has-icon-left">
                      <!--<input type="date" id="dtinput2" class="form-control" name="dtManufacturing" v-model="dataEquipment.dates.manufacturing" disabled>-->
                      <input
                        type="text"
                        id="dtinput2"
                        class="form-control"
                        name="dtManufacturing"
                        v-model="dataEquipment.dates.manufacturing"
                        disabled
                      />
                      <div class="form-control-position">
                        <i class="icon-calendar3"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="row mb-1"
                v-if="dataEquipment.ProductType == 'Refrigeration'"
              >
                <div class="col-md-12">
                  <h4 class="form-section">
                    <i class="icon-eye6"></i> {{ $t("equipm.titles.specif") }}
                  </h4>

                  <div class="row">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="userinput3">{{
                          $t("equipm.table.clClass")
                        }}</label>
                        <div class="position-relative has-icon-left">
                          <input
                            type="text"
                            id="userinput3"
                            class="form-control border-primary"
                            name="type"
                            v-model="dataEquipment.climaticClass"
                            disabled
                          />
                          <div class="form-control-position">
                            <i class="icon-brightness-contrast"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="userinput3">{{
                          $t("equipm.table.defrosting")
                        }}</label>
                        <div class="position-relative has-icon-left">
                          <input
                            type="text"
                            id="userinput3"
                            class="form-control border-primary"
                            name="type"
                            v-model="dataEquipment.defrosting"
                            disabled
                          />
                          <div class="form-control-position">
                            <i class="icon-svg"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="userinput3">{{
                          $t("equipm.table.maxPress")
                        }}</label>
                        <div class="position-relative has-icon-left">
                          <input
                            type="text"
                            id="userinput3"
                            class="form-control border-primary"
                            name="type"
                            v-model="dataEquipment.maxPressure"
                            disabled
                          />
                          <div class="form-control-position">
                            <i class="icon-meter"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="userinput3">{{
                          $t("equipm.table.protClass")
                        }}</label>
                        <div class="position-relative has-icon-left">
                          <input
                            type="text"
                            id="userinput3"
                            class="form-control border-primary"
                            name="type"
                            v-model="dataEquipment.protectionClass"
                            disabled
                          />
                          <div class="form-control-position">
                            <i class="icon-security"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="userinput3">{{
                          $t("equipm.table.currCons")
                        }}</label>
                        <div class="position-relative has-icon-left">
                          <input
                            type="text"
                            id="userinput3"
                            class="form-control border-primary"
                            name="type"
                            v-model="dataEquipment.ratedCurrent"
                            disabled
                          />
                          <div class="form-control-position">
                            <i class="icon-trending_up"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="userinput3">{{
                          $t("equipm.table.pwrConsump")
                        }}</label>
                        <div class="position-relative has-icon-left">
                          <input
                            type="text"
                            id="userinput3"
                            class="form-control border-primary"
                            name="type"
                            v-model="dataEquipment.ratedPinp"
                            disabled
                          />
                          <div class="form-control-position">
                            <i class="icon-power-cord"></i>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6 offset-md-3">
                      <div class="form-group">
                        <label for="userinput4">{{
                          $t("equipm.table.refrigerant")
                        }}</label>
                        <div class="position-relative has-icon-left">
                          <input
                            type="text"
                            id="userinput4"
                            class="form-control border-primary"
                            name="smth"
                            v-model="titleRefr"
                            disabled
                          />
                          <div class="form-control-position">
                            <i class="icon-lab"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- <div class="row mb-1">
                <div class="col-md-12">
                    <h4 class="form-section mb-0"><i class="icon-stack"></i> {{$t('equipm.titles.components')}}</h4>

                    <div class="mobileTbl table-responsive">
                        <table class="table table-hover mb-0" cellspacing="0">
                            <thead>
                              <tr>
                                <th style="vertical-align: middle;">{{$t('equipm.table.nameEq')}}</th>
                                <th style="vertical-align: middle;">{{$t('equipm.table.serNumber')}}</th>
                                <th style="vertical-align: middle;">{{$t('equipm.table.count')}}</th>
                                <th style="vertical-align: middle;">{{$t('equipm.table.manufacturer')}}</th>  
                              </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in dataEquipment.components" :key="index">
                                    <td :data-title="$t('equipm.table.nameEq')">{{ item.Item }}</td>
                                    <td :data-title="$t('equipm.table.serNumber')">{{ item.ItemSN }}</td>
                                    <td :data-title="$t('equipm.table.count')">{{ item.Quantity }}</td>
                                    <td :data-title="$t('equipm.table.manufacturer')">{{ item.Manufacturer }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>
              </div> -->

              <div class="row" v-if="dataEquipment.instructions.length > 0">
                <div class="col-md-12">
                  <h4 class="form-section">
                    <i class="icon-file-text2"></i
                    >{{ $t("equipm.table.instructions") }}:
                  </h4>
                  <div class="form-group">
                    <div
                      class="col-md-12"
                      v-for="(file, index) in dataEquipment.instructions"
                      :key="index"
                    >
                      <a>
                        <h4 @click="bringfile(file.name)">
                          <img
                            :src="getIcon(file.name)"
                            style="max-height: 2rem; min-height: 1rem"
                          />
                          <span style="text-decoration: underline">{{
                            file.name
                          }}</span>
                        </h4>
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <h4 class="form-section mb-0">
                    <i class="icon-location2"></i>
                    {{ $t("equipm.table.location") }}
                  </h4>

                  <!-- <div class="mobileTbl table-responsive">
                    <table class="table table-hover mb-0" cellspacing="0">
                        <thead>
                            <tr>
                                <th style="vertical-align: middle;">{{$t('equipm.table.country')}}</th>
                                <th style="vertical-align: middle;">{{$t('equipm.table.region')}}</th>
                                <th style="vertical-align: middle;">{{$t('equipm.table.city')}}</th>
                                <th style="vertical-align: middle;">{{$t('equipm.table.street')}}</th>
                                <th style="vertical-align: middle; width: 8%">{{$t('equipm.table.number')}}</th>
                                <th style="vertical-align: middle; width: 10%">{{$t('equipm.table.index')}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td :data-title="$t('equipm.table.country')">{{dataEquipment.addressT.country}}</td>
                                <td :data-title="$t('equipm.table.region')">{{dataEquipment.addressT.region}}</td>
                                <td :data-title="$t('equipm.table.city')">{{dataEquipment.addressT.city}}</td>
                                <td :data-title="$t('equipm.table.street')">{{dataEquipment.addressT.street}}</td>
                                <td :data-title="$t('equipm.table.number')">{{dataEquipment.addressT.streetN}}</td>
                                <td :data-title="$t('equipm.table.index')">{{dataEquipment.addressT.index}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div> -->

                  <div class="form-group">
                    <input
                      type="text"
                      id="address_old"
                      name="address_old"
                      class="form-control border-primary"
                      v-model="dataEquipment.address"
                      readonly
                    />
                  </div>
                </div>
              </div>

              <h4 class="form-section">
                <i class="icon-mail6"></i> {{ $t("equipm.table.contacts") }}
              </h4>

              <div class="form-group">
                <!--<label for="userinput5">{{$t('equipm.table.contacts')}}</label>-->
                <div class="position-relative has-icon-left">
                  <!--<input class="form-control border-primary" type="tel" placeholder="phone number" id="userinput5" pattern="[+]{1}[0-9]{11,14}" v-model="dataEquipment.contacts" disabled>-->
                  <textarea
                    class="form-control border-primary"
                    id="userinput5"
                    v-model="dataEquipment.contacts"
                  ></textarea>
                  <div class="form-control-position">
                    <i class="icon-address-book"></i>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-actions right" v-if="authorizeBtn">
              <button type="button" class="btn btn-auth btn-lg">
                <i class="icon-enter"></i
                ><router-link :to="{ name: 'login' }" style="color: white">
                  {{ $t("login.lbl.login") }}</router-link
                >
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import fileDownload from "js-file-download";

export default {
  name: "Product",
  components: {},
  data() {
    return {
      authorizeBtn: false,

      dataEquipment: {
        guid: null,
        serial: "", //ме-20123469393
        model: "",
        name: "",
        brand: "",
        article: "",
        refrigerant: {
          weight: "",
          name: "",
        },
        dates: {
          manufacturing: "",
          shipment: "",
        },
        contacts: "",
        climaticClass: "",
        defrosting: "",
        lightning: "",
        maxPressure: "",
        protectionClass: "",
        ratedCurrent: "",
        ratedPinp: "",
        address: null,
        addressT: {
          country: null,
          region: null,
          city: null,
          street: null,
          streetN: null,
          index: null,
        },
        //components: [],
        instructions: [],
      },
      find: {
        bySer: false,
        byModel: false,
      },
      showinfo: false,
      showInstr: false,
    };
  },
  methods: {
    getEqInfo(serial) {
      this.clearInfo();
      this.showinfo = false;
      this.showInstr = false;

      if (this.find.bySer && this.isValid(serial)) {
        this.find.byModel = false;
        this.dataEquipment.model = null;
        this.dataEquipment.serial = serial;
      } else {
        this.find.bySer = false;
      }

      if (this.find.byModel && this.isValid(this.dataEquipment.model)) {
        this.find.bySer = false;
        this.dataEquipment.serial = null;
      } else {
        this.find.byModel = false;
      }

      if (!this.find.bySer && !this.find.byModel) {
        this.showNotification(
          "custom-error",
          "Error",
          "Serial number can not be empty!"
        );
        return;
      }

      let dataRequest = { serial: null, codeModel: null, userGuid: null };

      dataRequest.serial = this.dataEquipment.serial;

      if (this.find.byModel) {
        if (
          this.isValid(this.dataEquipment.model) &&
          this.dataEquipment.model.indexOf("mod-") > -1
        ) {
          this.dataEquipment.model = this.dataEquipment.model.split("mod-")[1];
        }
        dataRequest.codeModel = this.dataEquipment.model;
      }

      this.makeQuery("/service/productSerial", { dataRequest: dataRequest })
        .then((result) => {
          if (this.find.bySer) {
            this.dataEquipment.name = result.Goods;
            this.dataEquipment.article = result.Articule;
            if (result.Model) {
              this.dataEquipment.model = result.Model;
            }

            if (result.GUID != undefined) {
              this.dataEquipment.guid = result.GUID;
            }
            if (result.ProductType) {
              this.dataEquipment.ProductType = result.ProductType;
              if (this.dataEquipment.ProductType == "FMCG Refrigeration") {
                this.dataEquipment.ProductType = "Refrigeration";
              }
            }
            this.dataEquipment.contacts = result.ContactInfo;

            this.dataEquipment.dates.manufacturing = this.dtFormat(
              result.DateOfProduction
            );
            this.dataEquipment.dates.shipment = this.dtFormat(
              result.DateOfShipment
            );
            this.dataEquipment.refrigerant.weight = result.RefrigerantMass;
            this.dataEquipment.refrigerant.name = result.RefrigerantBrand;
            this.dataEquipment.climaticClass = result.ClimaticClass;
            this.dataEquipment.defrosting = result.Defrosting;
            this.dataEquipment.lightning = result.Lightning;
            this.dataEquipment.maxPressure = result.MaxPressure;
            this.dataEquipment.protectionClass = result.ProtectionClass;
            this.dataEquipment.ratedCurrent = result.RatedCurrent;
            this.dataEquipment.ratedPinp = result.RatedPowerInput;

            if (result.Adress) {
              this.dataEquipment.address = result.Adress;
            }
            if (
              result.AdressSructure != undefined &&
              result.AdressSructure != null
            ) {
              this.dataEquipment.addressT.country =
                result.AdressSructure.Country;
              this.dataEquipment.addressT.region = result.AdressSructure.Region;
              this.dataEquipment.addressT.city = result.AdressSructure.Location;
              this.dataEquipment.addressT.street = result.AdressSructure.Street;
              this.dataEquipment.addressT.streetN =
                result.AdressSructure.StreetN;
              this.dataEquipment.addressT.index =
                result.AdressSructure.PostalCode;
            }

            /*if(result.ItemStructure != undefined){
                          for (let index = 0; index < result.ItemStructure.length; index++) {
                              this.dataEquipment.components.push(result.ItemStructure[index]);                                
                          }
                      }*/
            if (result.ArrayFiles != undefined) {
              this.dataEquipment.instructions = [];

              let file;
              for (let i = 0; i < result.ArrayFiles.length; i++) {
                file = result.ArrayFiles[i].name;
                if (file != null) {
                  this.dataEquipment.instructions.push({
                    name: file,
                    data: null,
                  });
                }
              }
            }

            //SerialNumber
            this.showinfo = true;
          } else if (this.find.byModel) {
            if (result.ArrayFiles.result == true) {
              this.dataEquipment.instructions = [];

              let file;
              for (let i = 0; i < result.ArrayFiles.data.length; i++) {
                file = result.ArrayFiles.data[i].name;
                if (file != null) {
                  this.dataEquipment.instructions.push({
                    name: file,
                    data: null,
                  });
                }
              }

              if (this.dataEquipment.instructions.length > 0) {
                this.showInstr = true;
              } else {
                this.showNotification(
                  "custom-info",
                  "instructions",
                  "Not found!"
                );
              }
            }
          }

          this.find.bySer = false;
          this.find.byModel = false;
        })
        .catch((result) => {
          this.showNotification("custom-error", "Error", result);
        });
    },
    getQr(ser) {
      this.find.bySer = true;
      this.getEqInfo(ser);
    },
    bringfile(fileName) {
      for (let i = 0; i < this.dataEquipment.instructions.length; i++) {
        if (
          fileName == this.dataEquipment.instructions[i].name &&
          this.dataEquipment.instructions[i].data != null
        ) {
          fileDownload(this.dataEquipment.instructions[i].data, fileName);
          return;
        }
      }

      let dataRequest = {
        serial: this.dataEquipment.serial,
        guid: this.dataEquipment.guid,
        codeModel: this.dataEquipment.model,
        nameFile: fileName,
      };
      this.makeQuery("/service/getproductinctruction", {
        dataRequest: dataRequest,
      })
        .then((result) => {
          if (result != null) {
            for (let i = 0; i < result.length; i++) {
              for (let j = 0; j < this.dataEquipment.instructions.length; j++) {
                if (
                  result[i].name == this.dataEquipment.instructions[j].name &&
                  (result[i].data != undefined || result[i].data != null)
                ) {
                  this.dataEquipment.instructions[j].data = this.base64String(
                    fileName,
                    result[i].data
                  ); // + result[i].data;
                  if (this.dataEquipment.instructions[j].data != null) {
                    fileDownload(
                      this.dataEquipment.instructions[j].data,
                      fileName
                    );
                    break;
                  } else {
                    this.showNotification(
                      "custom-info",
                      "instructions",
                      "Not allowed Type of file " +
                        fileName +
                        ", contact Modern ASU!"
                    );
                    break;
                  }
                }
                if (
                  result[i].name == this.dataEquipment.instructions[j].name &&
                  (result[i].data == undefined || result[i].data == null)
                ) {
                  this.showNotification(
                    "custom-info",
                    "instructions",
                    "No file there!"
                  );
                  break;
                }
              }
            }
          }
        })
        .catch((result) => {
          this.showNotification("custom-error", "Error", result);
        });
    },
    openURL(str) {
      window.open(str);
    },
    base64String(file, data) {
      let mediatype = "";

      const b64toBlob = (b64Data, contentType = "", sliceSize = 512) => {
        const byteCharacters = atob(b64Data);
        const byteArrays = [];

        for (
          let offset = 0;
          offset < byteCharacters.length;
          offset += sliceSize
        ) {
          const slice = byteCharacters.slice(offset, offset + sliceSize);

          const byteNumbers = new Array(slice.length);
          for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }

          const byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, { type: contentType });
        return blob;
      };

      if (file.indexOf(".xlsx") > -1) {
        mediatype =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      } else if (file.indexOf(".xls") > -1) {
        mediatype = "application/vnd.ms-excel";
      } else if (file.indexOf(".txt") > -1) {
        mediatype = "text/plain";
      } else if (file.indexOf(".xml") > -1) {
        mediatype = "text/xml";
      } else if (
        file.indexOf(".png") > -1 ||
        file.indexOf(".jpg") > -1 ||
        file.indexOf(".jpeg") > -1 ||
        file.indexOf(".png") > -1
      ) {
        mediatype = "image/png";
      } else if (file.indexOf(".pdf") > -1) {
        mediatype = "application/pdf";
      } else if (file.indexOf(".doc") > -1) {
        mediatype = "application/msword";
      } else if (file.indexOf(".docx") > -1) {
        mediatype =
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      } else if (file.indexOf(".gz") > -1) {
        mediatype = "application/gzip";
      } else if (file.indexOf(".rar") > -1) {
        mediatype = "application/vnd.rar";
      } else if (file.indexOf(".tar") > -1) {
        mediatype = "application/x-tar";
      } else if (file.indexOf(".ppt") > -1) {
        mediatype = "application/vnd.ms-powerpoint";
      } else if (file.indexOf(".pptx") > -1) {
        mediatype =
          "application/vnd.openxmlformats-officedocument.presentationml.presentation";
      } else if (file.indexOf(".vsd") > -1) {
        mediatype = "application/vnd.visio";
      } else if (file.indexOf(".zip") > -1) {
        mediatype = "application/zip";
      }

      if (mediatype != "") {
        return b64toBlob(data, mediatype); //'data:' + mediatype + ';base64,';
      } else {
        return null;
      }
    },
    clearInfo() {
      this.dataEquipment.serial = null;
      this.dataEquipment.guid = null;
      this.dataEquipment.name = null;
      this.dataEquipment.brand = null;
      this.dataEquipment.ProductType = null;
      this.dataEquipment.article = null;
      this.dataEquipment.refrigerant.weight = null;
      this.dataEquipment.refrigerant.name = null;
      this.dataEquipment.dates.manufacturing = null;
      this.dataEquipment.dates.shipment = null;
      this.dataEquipment.contacts = null;
      this.dataEquipment.climaticClass = null;
      this.dataEquipment.defrosting = null;
      this.dataEquipment.lightning = null;
      this.dataEquipment.maxPressure = null;
      this.dataEquipment.protectionClass = null;
      this.dataEquipment.ratedCurrent = null;
      this.dataEquipment.ratedPinp = null;

      this.dataEquipment.address = null;

      this.dataEquipment.addressT.country = null;
      this.dataEquipment.addressT.region = null;
      this.dataEquipment.addressT.city = null;
      this.dataEquipment.addressT.street = null;
      this.dataEquipment.addressT.streetN = null;
      this.dataEquipment.addressT.index = null;

      //this.dataEquipment.components = [];
      this.dataEquipment.instructions = [];
    },
    createAppeal() {
      //this.$router.push({ name: 'appeal', params: { serial: this.dataEquipment.serial, address: this.dataEquipment.address }, replace: true});
      this.showNotification(
        "custom-info",
        "Функціонал недоступний",
        "Сервіс Мodern Expo переходить на нову платформу. Будь ласка, зареєструйте своє звернення за <a class='bold' style='text-decoration: underline;' href='https://sp.modern-expo.com/public/form/ecbb669bb776adcf'> цим посиланням </a>",
        -1
      );
    },
  },
  computed: {
    titleRefr: function () {
      if (this.dataEquipment.refrigerant.name != "") {
        return (
          this.dataEquipment.refrigerant.name +
          " (" +
          this.dataEquipment.refrigerant.weight +
          ")"
        );
      }
    },
    listLanguages() {
      let arrLang = [];
      for (let i = 0; i < this.$i18n.availableLocales.length; i++) {
        arrLang[
          this.$i18n.getLocaleMessage(this.$i18n.availableLocales[i]).lang.id
        ] = this.$i18n.availableLocales[i];
      }
      return arrLang;
    },
  },
  components: {},
  mounted() {
    //console.log(this.$route.params);
    /* let usr = null;
            usr = localStorage.getItem("user-token");

            if (((usr != "") || 
                (usr != null) || 
                (usr != undefined))&&((this.$route.params.serial == undefined)||(this.$route.params.serial == null))){
              this.find.bySer = true;
              this.getEqInfo(this.dataEquipment.serial);
            }*/
  },
  watch: {
    /*'dataEquipment.refrigerant.weight': function(){
            return
          }*/
  },
  created() {
    //console.log(this.$route.params);
    if (
      this.$route.params.serial != null ||
      this.$route.params.serial != undefined
    ) {
      let ser = this.$route.params.serial;
      console.log(ser);

      if (ser.indexOf("mod-") < 0) {
        if (ser.indexOf("se-") < 0) {
          ser = "ме-" + ser.split("-")[1];
        }

        this.find.bySer = true;
        this.authorizeBtn = true;
        this.getEqInfo(ser);
      } else {
        this.find.bySer = false;
        this.find.byModel = true;
        this.authorizeBtn = true;
        this.dataEquipment.serial = null;
        this.dataEquipment.model = ser.split("mod-")[1];
        this.getEqInfo(null);
      }
    } else {
      let df = document.location.search;
      if (df.length > 0 && this.$route.params.serial == undefined) {
        if (df.indexOf("se-") < 0) {
          df = "ме-" + df.split("-")[1];
        }

        this.find.bySer = true;
        this.authorizeBtn = true;
        this.getEqInfo(df);
      }
    }
  },
};
</script>

<style>
.col-xs-4 {
  padding: 0;
}
.me_logo {
  background-image: url(../assets/icons/me_text.svg);
  background-size: contain;
  color: transparent !important;
  background-color: transparent !important;
  background-repeat: no-repeat;
}
</style>


// WEBPACK FOOTER //
// src/pages/Product.vue